import { section } from "@/neon";
import { add, qsa } from "@fluorescent/dom";

import isFirstSectionOnHomepage from "@/lib/homePage";
import { backgroundVideoHandler } from "@/lib/a11y";
import autoPlay from "@/lib/autoPlay";
import { animateVideoHero } from "@/lib/animation";

const selectors = {
  videoWrapper: ".video-hero__video",
};

section("video-hero", {
  onLoad() {
    const videoWrapper = qsa(selectors.videoWrapper, this.container);

    if (isFirstSectionOnHomepage(this.container)) {
      add(this.container, "first-full-height");
    }

    if (videoWrapper) {
      this.videoHandler = backgroundVideoHandler(this.container);
      autoPlay(videoWrapper);
    }
    this.animateVideoHero = animateVideoHero(this.container);
  },

  onUnload() {
    this.videoHandler && this.videoHandler();
    this.animateVideoHero?.destroy();
  },
});
